"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// import api from '../js/api.js'
// import accessWithKeyChain from '../js/helper.js'
var helper = require('../js/helper.js')["default"];

var errorHandler = require('../js/errors.js').handleError;

var search = {
  state: {
    capitalTypes: [],
    providerTypes: [],
    sectors: [],
    countries: [],
    descriptions: [],
    languages: [],
    socialMedias: [],
    stats: [],
    currencies: [],
    companies: [],
    providerList: [],
    loaded: false
  },
  getters: {
    getData: function getData(state) {
      return function (keyChain) {
        // keyChain = [keyName1, keyName2, {key3: keyName3, filterField: 'code', filterValue: 'codeValue'}]
        return helper.accessWithKeyChain(keyChain, state);
      };
    },
    capitalTypes: function capitalTypes(state) {
      return state.capitalTypes;
    },
    providerTypes: function providerTypes(state) {
      return state.providerTypes;
    },
    sectors: function sectors(state) {
      return state.sectors;
    },
    countries: function countries(state) {
      return state.countries;
    },
    countryNames: function countryNames(state) {
      return state.countries.map(function (item) {
        return item.name;
      });
    },
    devCountries: function devCountries(state) {
      return state.countries.filter(function (country) {
        return country.developing;
      });
    },
    nonDevCountries: function nonDevCountries(state) {
      return state.countries.filter(function (country) {
        return !country.developing;
      });
    },
    descriptions: function descriptions(state) {
      return state.descriptions;
    },
    languages: function languages(state) {
      return state.languages;
    },
    socialMedias: function socialMedias(state) {
      return state.socialMedias;
    },
    stats: function stats(state) {
      return state.stats;
    },
    currencies: function currencies(state) {
      return state.currencies;
    },
    companies: function companies(state) {
      return state.companies;
    },
    providerList: function providerList(state) {
      return state.providerList;
    },
    providerPropertyToProperty: function providerPropertyToProperty(state) {
      return function (propertyName, objectObject) {
        var list;

        if (state[propertyName]) {
          list = state[propertyName];
        } else {
          switch (propertyName) {
            case 'capital_type':
              list = state.capitalTypes;
              break;

            case 'provider_capital_types':
              list = state.capitalTypes;
              break;

            case 'provider_type':
              list = state.providerTypes;
              break;

            case 'provider_provider_types':
              list = state.providerTypes;
              break;

            case 'sector':
              list = state.sectors;
              break;

            case 'provider_sectors':
              list = state.sectors;
              break;

            case 'country':
              list = state.countries;
              break;

            case 'provider_countries':
              list = state.countries;
              break;

            case 'provider_stats':
              list = state.stats;
              break;

            case 'stat':
              list = state.stats;
              break;

            case 'provider_descriptions':
              list = state.descriptions;
              break;

            case 'description':
              list = state.descriptions;
              break;

            case 'provider_currencies':
              list = state.currencies;
              break;

            case 'currency':
              list = state.currencies;
              break;

            case 'language':
              list = state.languages;
              break;

            case 'provider_languages':
              list = state.languages;
              break;

            case 'social_media':
              list = state.socialMedias;
              break;

            case 'provider_social_medias':
              list = state.socialMedias;
              break;
          }
        }

        if (objectObject == undefined) {
          return list;
        } else {
          return list.find(function (item) {
            return item.id == objectObject[propertyName + '_id'];
          });
        }
      };
    }
  },
  mutations: {
    setCapitalTypes: function setCapitalTypes(state, data) {
      state.capitalTypes = data;
    },
    setProviderTypes: function setProviderTypes(state, data) {
      state.providerTypes = data;
    },
    setCountries: function setCountries(state, data) {
      state.countries = data;
    },
    setSectors: function setSectors(state, data) {
      state.sectors = data;
    },
    setDescriptions: function setDescriptions(state, data) {
      state.descriptions = data;
    },
    setLanguages: function setLanguages(state, data) {
      state.languages = data;
    },
    setSocialMedias: function setSocialMedias(state, data) {
      state.socialMedias = data;
    },
    setStats: function setStats(state, data) {
      state.stats = data;
    },
    setCurrencies: function setCurrencies(state, data) {
      state.currencies = data;
    },
    setCompanies: function setCompanies(state, data) {
      state.companies = data;
    },
    setproviderList: function setproviderList(state, data) {
      state.providerList = data;
    }
  },
  actions: _defineProperty({
    fetchCapitalTypes: function fetchCapitalTypes(context) {
      return context.getters.api.capitalType.index(context.getters.token, -1).then(function (r) {
        context.commit('setCapitalTypes', r.data._items);
      });
    },
    fetchProviderTypes: function fetchProviderTypes(context) {
      return context.getters.api.providerType.index(context.getters.token, -1).then(function (r) {
        context.commit('setProviderTypes', r.data._items);
      });
    },
    fetchCountries: function fetchCountries(context) {
      return context.getters.api.country.index(context.getters.token, -1).then(function (r) {
        context.commit('setCountries', r.data._items);
      });
    },
    fetchSectors: function fetchSectors(context) {
      return context.getters.api.sector.index(context.getters.token, -1).then(function (r) {
        context.commit('setSectors', r.data._items);
      });
    },
    fetchDescriptions: function fetchDescriptions(context) {
      return context.getters.api.description.index(context.getters.token, -1).then(function (r) {
        context.commit('setDescriptions', r.data._items);
      });
    },
    fetchLanguages: function fetchLanguages(context) {
      return context.getters.api.language.index(context.getters.token, -1).then(function (r) {
        context.commit('setLanguages', r.data._items);
      });
    },
    fetchSocialMedias: function fetchSocialMedias(context) {
      return context.getters.api.socialMedia.index(context.getters.token, -1).then(function (r) {
        context.commit('setSocialMedias', r.data._items);
      });
    },
    fetchStats: function fetchStats(context) {
      return context.getters.api.stat.index(context.getters.token, -1).then(function (r) {
        context.commit('setStats', r.data._items);
      });
    },
    fetchCurrencies: function fetchCurrencies(context) {
      return context.getters.api.currency.index(context.getters.token, -1).then(function (r) {
        context.commit('setCurrencies', r.data._items);
      });
    },
    fetchCompanies: function fetchCompanies(context) {
      return context.getters.api.company.index(context.getters.token, -1).then(function (r) {
        context.commit('setCompanies', r.data._items);
      });
    },
    fetchproviderList: function fetchproviderList(context) {
      return context.getters.api.providerList.index(context.getters.token, -1).then(function (r) {
        context.commit('setproviderList', r.data._items);
      });
    }
  }, "fetchproviderList", function fetchproviderList(context) {
    var errorEvent = false;
    var results = [];
    var i = 1;
    context.getters.api.providerList.index(context.getters.token, -1).then(
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(r) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return context.getters.api.providerList.index(context.getters.token, -1, i)["catch"](function (error) {
                  errorEvent = true;
                  throw error;
                }).then(function (r) {
                  if (!errorEvent) {
                    results.push.apply(results, _toConsumableArray(r.data._items));
                  }

                  i++;
                });

              case 2:
                response = _context.sent;

              case 3:
                if (!errorEvent && results.length < r.data._meta.total) {
                  _context.next = 0;
                  break;
                }

              case 4:
                context.commit('setproviderList', results);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())["catch"](function (err) {
      return errorHandler(err, context);
    });
  })
};
var _default = search;
exports["default"] = _default;


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/modules/searchParams.js